import { render } from "./SaveRemoveBtns.vue?vue&type=template&id=a5ee5d7a&scoped=true"
import script from "./SaveRemoveBtns.vue?vue&type=script&lang=js"
export * from "./SaveRemoveBtns.vue?vue&type=script&lang=js"

import "./SaveRemoveBtns.vue?vue&type=style&index=0&id=a5ee5d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ee5d7a"]])

export default __exports__